
export const socketurl='wss://001-0005-bakdataaa.umojaimcouriers.com'

//https://1-be-pifs01-mta-app1.pitech.co.ug
//127.0.0.1:8000
//138.197.8.179'
//https://001-0005-bakdataaa.umojaimcouriers.com